"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = exports.PureSearch = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _components = require("@insided/shared/services/algolia/components");

var _connectors = require("@insided/shared/services/algolia/connectors");

var _algolia = require("@insided/shared/services/algolia");

var _AlgoliaSearch = _interopRequireDefault(require("./AlgoliaSearch"));

var _AlgoliaSearchForControl = _interopRequireDefault(require("./AlgoliaSearchForControl"));

var _SearchBox = require("./SearchBox");

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var _Button = _interopRequireDefault(require("@insided/deprecated-control/ui-components/Button"));

var _phrase = _interopRequireDefault(require("../../../libs/translationsUtils/phrase"));

var _common = require("@insided/shared/utils/common");

var _algoliaService = require("../../../services/algoliaService");

var _components2 = require("@insided/destination/modules/Search/components");

var _resetFilters = require("@insided/destination/modules/Search/utils/resetFilters");

var _utils = require("@insided/destination/modules/Search/utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SearchWithAutoComplete = (0, _connectors.connectAutoComplete)((0, _connectors.connectStateResults)(_AlgoliaSearch.default));
var SearchWithAutoCompleteForControl = (0, _connectors.connectAutoComplete)((0, _connectors.connectStateResults)(_AlgoliaSearchForControl.default));
var cssAnchorName = 'algolia-search';
exports.cssAnchorName = cssAnchorName;

function shouldDisplayFilterButton() {
  var _ref, _document$querySelect;

  if (typeof window === 'undefined') return false;
  return Boolean((_ref = (_document$querySelect = document.querySelector('[data-preact="destination/modules/Navigation/WidgetCategoryFilter/index.sync"]')) !== null && _document$querySelect !== void 0 ? _document$querySelect : document.querySelector('[data-preact="ideation-destination/filters/ProductAreaFilter"]')) !== null && _ref !== void 0 ? _ref : document.querySelector('[data-preact="ideation-destination/filters/IdeaStatusFilter"]'));
}

function getContentType(contentTypes, isControl) {
  var searchWithContentTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (isControl && !searchWithContentTypes) return undefined;
  if (contentTypes) return contentTypes;
  if (typeof window === 'undefined') return undefined;

  if (window.location.pathname.match(/^\/ideas/)) {
    return ['ideation'];
  }

  if (window.location.pathname.match(/^\/product-updates/)) {
    return ['productUpdate'];
  }

  if (window.location.pathname.match(/^\/events/)) {
    return ['event'];
  }

  return undefined;
}

var Search = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Search, _Component);

  var _super = _createSuper(Search);

  function Search(props) {
    var _this$props$isControl;

    var _this;

    (0, _classCallCheck2.default)(this, Search);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "communityId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "defaultIndexList", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      searchById: false,
      searchByContentType: getContentType(_this.props.searchByContentType, (_this$props$isControl = _this.props.isControl) !== null && _this$props$isControl !== void 0 ? _this$props$isControl : false, _this.props.searchWithContentTypes),
      finalInput: '',
      searchClient: undefined,
      listIndexes: [],
      isFiltersOverlay: false,
      isZendeskFederatedSearch: false,
      hiddenCategories: []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateSearch", function (searchTerm, next) {
      var contentTypes = searchTerm.contentType ? [searchTerm.contentType] : undefined;

      if (!(searchTerm.contentType && !_this.props.searchWithContentTypes)) {
        var _this$props$isControl2;

        contentTypes = getContentType(_this.props.searchByContentType, (_this$props$isControl2 = _this.props.isControl) !== null && _this$props$isControl2 !== void 0 ? _this$props$isControl2 : false, _this.props.searchWithContentTypes);
      }

      _this.setState({
        searchById: searchTerm.q.match(/^[0-9]+$/) !== null,
        finalInput: searchTerm.q,
        searchByContentType: contentTypes
      }, next);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "callback", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(data) {
        var _yield$Promise$all, _yield$Promise$all2, searchClient, _basicClient, originalSearch, indexes;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Promise.all([(0, _algolia.createAlgoliaClient)(data.client_id, data.token), (0, _algolia.createAlgoliaClient)(data.client_id, data.basicToken)]);

              case 2:
                _yield$Promise$all = _context2.sent;
                _yield$Promise$all2 = (0, _slicedToArray2.default)(_yield$Promise$all, 2);
                searchClient = _yield$Promise$all2[0];
                _basicClient = _yield$Promise$all2[1];

                _this.setState({
                  isZendeskFederatedSearch: data.isZendeskFederatedSearchEnabled,
                  hiddenCategories: data.hiddenCategories
                }); // do not make a search query when the input is empty


                originalSearch = searchClient.search.bind(searchClient);

                searchClient.search = /*#__PURE__*/function () {
                  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(requests, _) {
                    return _regenerator.default.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!requests.some(function (request) {
                              var _request$params;

                              return (request === null || request === void 0 ? void 0 : (_request$params = request.params) === null || _request$params === void 0 ? void 0 : _request$params.query) === '';
                            })) {
                              _context.next = 2;
                              break;
                            }

                            return _context.abrupt("return", {
                              results: []
                            });

                          case 2:
                            return _context.abrupt("return", originalSearch(requests));

                          case 3:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2, _x3) {
                    return _ref3.apply(this, arguments);
                  };
                }(); // Use pre-computed availableIndexes from backend (unified index is always enabled)


                indexes = data.availableIndexes && data.availableIndexes.length > 0 ? data.availableIndexes : _this.defaultIndexList;

                _this.setState({
                  listIndexes: indexes,
                  searchClient: searchClient
                });

                (0, _algoliaService.insights)('init', {
                  appId: data.client_id,
                  apiKey: data.token
                });

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _this.communityId = (0, _utils.getCommunityId)(); // Unified index is always enabled

    _this.defaultIndexList = ["".concat(_this.communityId, "-unified")];
    return _this;
  }

  (0, _createClass2.default)(Search, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _algoliaService.getSearchToken)(this.callback);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "revertFilters",
    value: function revertFilters(e) {
      e.stopPropagation();
      e.preventDefault();
      window.dispatchEvent(new CustomEvent('revertFilters'));
      this.filtersOverlayHandler(e, false);
    }
  }, {
    key: "filtersOverlayHandler",
    value: function filtersOverlayHandler(e, value) {
      var _this2 = this;

      e.stopPropagation();
      e.preventDefault();
      window.dispatchEvent(new CustomEvent('filter', {
        detail: {
          display: value
        }
      }));

      if (value) {
        this.setState({
          isFiltersOverlay: value
        });
      } else {
        /*
          Items that should be in the filters are added via Portal component
          having setTimeout here is making state change async and give time to filter component to unmount
        */
        window.setTimeout(function () {
          _this2.setState(function (state) {
            return {
              isFiltersOverlay: !state.isFiltersOverlay
            };
          });
        }, 0);
      }

      var bodyEl = document.querySelector('body');

      if (bodyEl) {
        if (bodyEl.style.overflow === 'hidden') {
          bodyEl.style.overflow = 'visible';
        } else {
          bodyEl.style.overflow = 'hidden';
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props$submitIconType2,
          _this3 = this;

      var props = this.props,
          state = this.state;

      if (!state.searchClient) {
        var _props$submitIconType;

        return (0, _preact.h)(_SearchBox.SearchBox, {
          submitIconType: (_props$submitIconType = props.submitIconType) !== null && _props$submitIconType !== void 0 ? _props$submitIconType : '',
          enableFocusToSearch: props.enableFocusToSearch,
          className: props.searchBoxClassName,
          isControl: props.isControl,
          placeholder: props.searchPlaceholder
        });
      }

      return (0, _preact.h)("div", {
        className: "search-and-filter-wrapper",
        "data-bounded-context": "Search"
      }, (0, _preact.h)(PureSearch, (0, _extends2.default)({}, props, {
        searchClient: state.searchClient,
        updateSearch: this.updateSearch,
        searchById: state.searchById,
        searchByContentType: state.searchByContentType,
        finalInput: state.finalInput,
        communityId: this.communityId,
        submitIconType: (_props$submitIconType2 = props.submitIconType) !== null && _props$submitIconType2 !== void 0 ? _props$submitIconType2 : '',
        listIndexes: state.listIndexes,
        isZendeskFederatedSearch: state.isZendeskFederatedSearch,
        hiddenCategories: state.hiddenCategories
      })), shouldDisplayFilterButton() && (0, _preact.h)(_components2.InstantSearchFilterButton, {
        onClick: function onClick(event) {
          return _this3.filtersOverlayHandler(event, true);
        }
      }), state.isFiltersOverlay && (0, _preact.h)("div", {
        className: "instant-search__results-wrapper is-hidden-L"
      }, (0, _preact.h)("div", {
        className: "instant-search__results-wrapper-filter ".concat(!state.isFiltersOverlay ? 'instant-search__results-wrapper-filter--hide' : '')
      }, (0, _preact.h)("div", {
        className: "instant-search__results-wrapper-filter-header"
      }, (0, _preact.h)(_Close.default, {
        onClick: function onClick(e) {
          return _this3.revertFilters(e);
        },
        role: "button",
        tabIndex: 0,
        "aria-label": "Close filters",
        style: {
          cursor: 'pointer'
        }
      }), (0, _preact.h)("h3", {
        className: "instant-search__results-wrapper-filter-header-heading"
      }, (0, _preact.h)(_phrase.default, {
        p: "advanced.search.filters"
      })), (0, _preact.h)("button", {
        onClick: _resetFilters.resetFilters,
        className: "instant-search__results-wrapper-filter-header-btn"
      }, (0, _preact.h)(_phrase.default, {
        m: "Common",
        p: "advanced.search.filter.clear.all"
      }))), (0, _preact.h)("div", {
        className: "instant-search__results-wrapper-filters"
      }), (0, _preact.h)("div", {
        className: "instant-search__results-wrapper-filter-show-more-wrapper"
      }, (0, _preact.h)(_Button.default, {
        cta: true,
        className: "instant-search__results-wrapper-filter-show-more",
        onClick: function onClick(event) {
          return _this3.filtersOverlayHandler(event, false);
        }
      }, (0, _preact.h)(_phrase.default, {
        p: "show.results"
      }))))));
    }
  }]);
  return Search;
}(_preact.Component);

var PureSearch = function PureSearch(props) {
  var _props$submitIconType3;

  var hasCommunityIndex = props.listIndexes.includes(props.communityId);
  var dataSources = {
    skilljar: !!props.isFederatedSkilljarSearch,
    salesforce: !!props.isFederatedSalesforceSearch,
    freshdesk: !!props.isFederatedFreshdeskSearch,
    zendesk: props.isZendeskFederatedSearch,
    federated: _common.common.isModuleActive('federatedSearchApi')
  };
  var includedDataSources = Object.keys(dataSources).filter(function (key) {
    return dataSources[key];
  });
  return (0, _preact.h)(_components.InstantSearch, {
    searchClient: props.searchClient,
    indexName: props.communityId
  }, (hasCommunityIndex || _common.common.isModuleActive('unifiedIndexEnabled')) && (0, _preact.h)(_components.Index, {
    indexName: props.communityId
  }, (0, _preact.h)(_components.Configure, {
    hitsPerPage: 5,
    filters: (0, _utils.getFilters)(props, includedDataSources),
    queryType: props.searchById ? 'prefixNone' : 'prefixLast',
    clickAnalytics: true,
    analyticsTags: props.isControl ? ['control'] : ['destination', 'live'],
    restrictSearchableAttributes: props.searchById ? ['id', 'private_id'] : ['title', 'first_post', 'answer', 'reply', 'tags', 'forum_title', 'category_title', 'product_area_title', 'content']
  })), !_common.common.isModuleActive('unifiedIndexEnabled') && (0, _preact.h)("div", {
    hidden: true
  }, props.isFederatedSalesforceSearch && props.listIndexes.includes("".concat(props.communityId, "-salesforce")) && (0, _preact.h)(_components.Index, {
    indexName: "".concat(props.communityId, "-salesforce")
  }, (0, _preact.h)(_components.Configure, {
    hitsPerPage: 3,
    filters: (0, _utils.getFilters)(props),
    clickAnalytics: true,
    analyticsTags: props.isControl ? ['control'] : ['destination', 'live']
  })), props.isFederatedSkilljarSearch && props.listIndexes.includes("".concat(props.communityId, "-skilljar")) && (0, _preact.h)(_components.Index, {
    indexName: "".concat(props.communityId, "-skilljar")
  }, (0, _preact.h)(_components.Configure, {
    hitsPerPage: 3,
    clickAnalytics: true
  })), props.isFederatedFreshdeskSearch && props.listIndexes.includes("".concat(props.communityId, "-freshdesk")) && (0, _preact.h)(_components.Index, {
    indexName: "".concat(props.communityId, "-freshdesk")
  }, (0, _preact.h)(_components.Configure, {
    hitsPerPage: 3,
    clickAnalytics: true
  })), props.isZendeskFederatedSearch && props.listIndexes.includes("".concat(props.communityId, "-zendesk")) && (0, _preact.h)(_components.Index, {
    indexName: "".concat(props.communityId, "-zendesk")
  }, (0, _preact.h)(_components.Configure, {
    hitsPerPage: 3,
    clickAnalytics: true
  })), props.listIndexes.includes("".concat(props.communityId, "-federated")) && (0, _preact.h)(_components.Index, {
    indexName: "".concat(props.communityId, "-federated")
  }, (0, _preact.h)(_components.Configure, {
    hitsPerPage: 20,
    clickAnalytics: true
  }))), props.isControl ? (0, _preact.h)(SearchWithAutoCompleteForControl, {
    updateSearch: function updateSearch(value, next) {
      return props.updateSearch(value, next);
    },
    searchById: props.searchById,
    finalInput: props.finalInput,
    placeholder: props.searchPlaceholder,
    callback: props.callback,
    exclude: props.exclude,
    newStyle: !!props.newStyle,
    submitIconType: (_props$submitIconType3 = props.submitIconType) !== null && _props$submitIconType3 !== void 0 ? _props$submitIconType3 : '',
    withoutRedirect: props.withoutRedirect,
    searchBoxClassName: props.searchBoxClassName
  }) : (0, _preact.h)(SearchWithAutoComplete, {
    updateSearch: function updateSearch(value, next) {
      return props.updateSearch(value, next);
    },
    callback: props.callback,
    indexName: props.communityId,
    enableFocusToSearch: props.enableFocusToSearch,
    callbackOnOutsideClick: props.callbackOnOutsideClick
  }));
};

exports.PureSearch = PureSearch;
var _default = Search;
exports.default = _default;